import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';
import SupportButton from './SupportButton';
import SupportTicketsPanel from './SupportTicketsPanel';

// THE SUPPORT TAB of a product screen — the tickets raised about THIS instance (this sync project, vault, porter,
// pipeline …) and the button that raises the next one, in place of the Support button the screens had in their
// header. Same shared button and ticket route as before (CLAUDE.md rich-context ticket): the screen's context builder
// still goes with the ticket, now with the product and its id so the ticket lists here.
//
//   product    the audit PRODUCTS name — 'Sync', 'Vault', 'PaymentPorter', 'Pipelines', …
//   productId  the instance's id (syncid, v2_vault.id, …). The server reads its owner from that, so the list and a new
//              ticket are checked against the instance itself. Omitted: the product's tickets at hotelId / accountId.
//   hotelId / accountId   where to look when there is no single instance (a product's overview screen)
//   context    the SupportButton context (object or function); product and productId are added to it
//   noun       how the empty list names the instance ("this sync project")
//
// SUPPORT_TAB is the tab entry for a shared Tabs bar. useSupportTab(mainKey) is the tab state for a screen whose only
// other view is its main one: ?tab=support opens on Support (a link can), anything else is mainKey, other query
// parameters are kept.
export const SUPPORT_TAB = { key: 'support', label: 'Support', icon: <LifeBuoy size={20} /> };

export function useSupportTab(mainKey) {
    const [searchParams, setSearchParams] = useSearchParams();
    const tab = searchParams.get('tab') === 'support' ? 'support' : mainKey;
    const setTab = (t) => {
        const next = new URLSearchParams(searchParams);
        if (t === 'support') next.set('tab', 'support'); else next.delete('tab');
        setSearchParams(next, { replace: true });
    };
    return [tab, setTab];
}

export default function ProductSupportTab({ product, productId, hotelId, accountId, context, noun = 'this' }) {
    const [reloadKey, setReloadKey] = useState(0);
    const withProduct = () => ({
        ...(typeof context === 'function' ? context() : context || {}),
        product, ...(productId ? { productId } : {}),
    });
    return (
        <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', marginBottom: '1rem' }}>
                <p style={{ color: '#6b7280', margin: 0 }}>
                    Tickets raised about {noun}. What you are looking at is attached to a new ticket for the support team automatically.
                </p>
                <SupportButton context={withProduct} label="New ticket" variant="primary" onRaised={() => setReloadKey(k => k + 1)} />
            </div>
            <SupportTicketsPanel scope="product" product={product} productId={productId}
                hotelId={productId ? undefined : hotelId} accountId={productId || hotelId ? undefined : accountId}
                reloadKey={reloadKey} emptyText={`No support tickets about ${noun} yet`} />
        </div>
    );
}
